module.exports = __webpack_public_path__ + "media/images/lb/683-9a85e2746df10e9802999a1489b2f7a6.svg";